import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { computed } from 'vue'
import { ADOType } from '@/types/types'
import useI18nTl from '@/hooks/useI18nTl'

0
import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'Payees',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  ados: {
    type: Array,
    default: () => [],
    Request: true,
  },
},
  setup(__props) {

const props = __props

const { tl } = useI18nTl('Operation')



const ados = computed(() => {
  return props.ados
})

const adoDesc = (ado: any): string => {
  return ado.payeeId
}

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ados), (ado) => {
    return (_openBlock(), _createElementBlock("div", {
      key: ado.id,
      class: "tariff-row"
    }, [
      _createVNode(_component_el_tooltip, { placement: "top" }, {
        content: _withCtx(() => [
          _createElementVNode("div", null, _toDisplayString(adoDesc(ado)), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_tag, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(ado.payeeName) + " : " + _toDisplayString(ado.percentage) + " %", 1)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024)
    ]))
  }), 128))
}
}

})